// React component for a modern Treile scanning page
import { Helmet } from "react-helmet";
import React, { useState, useEffect } from "react";
import "./TreileScanningPage.css"; // Assuming a CSS file for styling

const TreileScanningPage = () => {
  const [visitorInfo, setVisitorInfo] = useState({});
  const [binaryLine, setBinaryLine] = useState("1010101010");
  const [randomData, setRandomData] = useState([]);

  useEffect(() => {
    // Simulating fetching visitor info (you could replace this with actual API calls)
    fetch("https://api64.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setVisitorInfo((prev) => ({
          ...prev,
          ip: data.ip,
          timestamp: new Date().toLocaleString(),
        }));
      });

    // Function to generate random alphanumeric data
    const generateRandomData = () => {
      const randomLines = Array.from({ length: 10 }, () => {
        return Math.random().toString(36).substring(2, 12).toUpperCase();
      });
      setRandomData(randomLines);
    };

    // Update binary line every 200ms
    const binaryInterval = setInterval(() => {
      setBinaryLine(
        Array.from({ length: 40 }, () => (Math.random() > 0.5 ? "1" : "0")).join("")
      );
    }, 200);

    // Continuously update random data
    const intervalId = setInterval(() => {
      generateRandomData();
    }, 200); // Update every 200ms

    return () => {
      clearInterval(intervalId);
      clearInterval(binaryInterval);
    };
  }, []);

  return (
    <div className="treile-scanning-page">
      <Helmet>
        <title>Treile.com</title>
      </Helmet>
      <div className="treile-image-container">
        <img
          src="/treile-image.png"
          alt="Treile scanning"
          className="scanning"
        />
        <div className="scan-overlay"></div>
      </div>

      <div className="random-data">
        {randomData.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>

      <>
        <div className="visitor-info">
          <p>IP ADDRESS: <span>{visitorInfo.ip || "LOADING..."}</span></p>
          <p>VISIT TIME: <span>{visitorInfo.timestamp || "LOADING..."}</span></p>
        </div>
        <div className="gps-radar">
          <div className="radar-circle">
            <div className="radar-grid"></div>
            <div className="radar-line"></div>
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="radar-dot"
                style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                }}
              ></div>
            ))}
          </div>
        </div>
        <div className="binary-line">{binaryLine}</div>
        <div className="status">Status: Scanning...</div>
        <div className="branding">TREILE.COM</div>
      </>
    </div>
  );
};

export default TreileScanningPage;